import { FlexRow } from '@editor/components/utilities/layouts';
import styled from 'styled-components';

export const CreditsWrapper = styled(FlexRow)`
  padding-right: 4px;
`;
